var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAimIcon = function SvgAimIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "aim-icon_svg__b",
    width: "105.8%",
    height: "103.8%",
    x: "-2.9%",
    y: "-1.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "aim-icon_svg__a",
    d: "M0 0h800v1196H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-624-316H816v1459H-624z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aim-icon_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aim-icon_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aim-icon_svg__a",
    fill: "#000",
    filter: "url(#aim-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aim-icon_svg__a",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#aim-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "m44.207 84.257.354 3.182 3.182.354-2.763 2.763q.107.176.206.354A10.45 10.45 0 0 1 46.5 96c0 5.799-4.701 10.5-10.5 10.5S25.5 101.799 25.5 96 30.201 85.5 36 85.5c2.074 0 4.06.603 5.756 1.717l-.312-.198zM36 86.5a9.5 9.5 0 1 0 9.5 9.5 9.45 9.45 0 0 0-1.25-4.713l-.043.041-2.546-.283-.016.017a7.5 7.5 0 1 1-.707-.707l.016-.017-.282-2.545.042-.043A9.45 9.45 0 0 0 36 86.5m0 3a6.5 6.5 0 1 0 4.936 2.271l-1.42 1.42a4.5 4.5 0 1 1-.708-.708l1.422-1.419A6.47 6.47 0 0 0 36 89.5m0 3a3.5 3.5 0 1 0 2.804 1.405l-2.524 2.522a.5.5 0 1 1-.707-.707l2.524-2.523A3.5 3.5 0 0 0 36 92.5m7.443-6.064-1.724 1.724.212 1.91 1.909.211 1.724-1.724-1.909-.212z"
  }))))));
};
export default SvgAimIcon;